import { z } from "zod";
import { MAX_MENTIONS_PER_CONTENT } from "../../utils/mentions.js";
import { MediaType } from "../enum.js";
import { overlayTextsSchema } from "../overlay-text.js";

export const createPostSchema = z.object({
	group_id: z.string(),
	caption: z.string().max(200).optional(),
	overlay_texts: overlayTextsSchema,
	mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
	media: z
		.array(
			z.object({
				media_url: z.string(),
				media_type: z.enum([MediaType.IMAGE, MediaType.VIDEO]),
				position: z.number(),
				zoom: z.number().min(0.25).max(4).optional(),
				rotation: z.number().optional(),
				background_color: z.string().nullable().optional(),
			}),
		)
		.min(1)
		.max(6),
});

export type CreatePostPayload = z.infer<typeof createPostSchema>;
